import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';

export interface CashAmountPrompt {
  askAmount(totalAmount: number): Observable<number>;
}

export const CASH_AMOUNT_PROMPT = new InjectionToken<CashAmountPrompt>('CASH_AMOUNT_PROMPT');
